import React, { useState, useRef } from 'react';
import Image from 'next/legacy/image';
import cx from 'classnames';

import { useEscapeEvent } from '../../hooks/useEscapeEvent';
import { useRefClickEvent } from '../../hooks/useRefClickEvent';

import infoIcon from '@/images/info-icon.svg';

export function PopUp() {
  const [visibility, setVisibility] = useState(false);
  const popUpBubbleRef = useRef(null);

  const showPopUp = () => {
    setVisibility(!visibility);
  };

  useEscapeEvent(showPopUp);
  useRefClickEvent(popUpBubbleRef, showPopUp);

  return (
    <div
      ref={popUpBubbleRef}
      data-elementid="no-spam-pop-up"
      className="hidden min-w-[24px] desktop:relative ml-2 desktop:ml-3"
    >
      <Image
        src={infoIcon}
        onClick={showPopUp}
        alt="pop-up icon"
        className="w-full hover:cursor-pointer"
      />
      <div
        className={cx(
          'absolute bg-white text-[12px] text-blackberry',
          'px-6 py-1',
          'rounded-[20px]',
          'leading-5',
          'mx-auto left-0 right-0',
          'w-[95%]',
          '-top-3',
          'max-[350px]:-top-4',
          'tablet:min-h-[100px] tablet:top-2 tablet:left-[76%]',
          'desktop:-top-[112px] desktop:w-[320px] desktop:left-[-282px] desktop:z-[5] desktop:opacity-95',
          'flex items-center',
          'min-h-[75px]',
          'shadow-[0px_0px_10px_rgba(0,0,0,0.25)]',
          'after:content-[""] after:absolute after:w-0 after:h-0',
          'after:border-l-[7px] after:border-l-transparent',
          'after:border-r-[7px] after:border-r-transparent',
          'after:border-t-[10px] after:border-t-white',
          'after:clear-both',
          'after:left-[87%] after:top-[98%]',
          'min-[425px]:after:left-[82%]',
          'tablet:after:left-[76%] tablet:after:top-full',
          'desktop:after:left-[288px]',
          visibility ? 'flex' : 'hidden'
        )}
      >
        <p>
          We&apos;ll send you a confirmation code to get started — we don&apos;t believe
          in spam!
        </p>
      </div>
    </div>
  );
}
